/**
 * Общи данни за юридическото лице и помощни компоненти за правните страници.
 */
import React from 'react';

export const COMPANY = {
  name: '„ГеоРоуд" ЕООД',
  eik: '204977764',
  address: 'гр. Варна 9000, район „Младост", ж.к. „Младост", бл. 127А',
  phone: '0898 444 269',
  email: 'georoud@abv.bg',
  product: 'APP 4 FARMERS',
  // Хостинг доставчик: DigitalOcean, LLC — дата центрове в ЕС (Амстердам/Франкфурт).
  // Доставчикът е със седалище в САЩ → виж защитните мерки в т. „Трансфери".
  hosting: 'DigitalOcean, LLC',
  hostingLocation: 'ЕС (Амстердам/Франкфурт)',
};

// Дата по подразбиране — за документите, непипани след 19.07.2026. Отделен
// документ подава своя дата на LegalLayout (`updated`); иначе смяната на един
// текст би казала на човека да препрочете и трите.
export const LAST_UPDATED = '19.07.2026';
export const VERSION = '1.1';

// Контактен блок с данните на дружеството. `title` по избор (иначе името).
export const ContactBlock = ({title}) => (
  <div className="contact-info">
    <h4>{title || COMPANY.name}</h4>
    {title && <p>{COMPANY.name}</p>}
    <p>ЕИК: {COMPANY.eik}</p>
    <p>Адрес: {COMPANY.address}</p>
    <p>Телефон: <a href="tel:+359898444269">{COMPANY.phone}</a></p>
    <p>Email: <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a></p>
  </div>
);
